import React, { useEffect, useState } from "react"
import { FlatList, RefreshControl, View } from "react-native"
import styles from "./styles"
import { WorkShopService } from "@Services/Workshop.Service"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import CustomWorkshopItem from "@Components/CustomWorkshopItem/CustomWorkshopItem"
import { ActivityIndicator } from "react-native-paper"
import { baseColors } from "@Constants/baseStyles"
import { useIsFocused } from "@react-navigation/native"
import CustomEmptyData from "@Components/CustomEmptyData"
import { UseParisDateTimeZone, dateTimeFR, localDateFormat } from "@Utils/utils"
import moment from "moment"

const Ateliers = (props) => {
    const [fetching, setFetching] = useState(false)
    const [workshops, setWorkshops] = useState([])
    const user = useRecoilValue(userAtom)
    const isFocused = useIsFocused()

    const alreadyMember = (attendes) => {
        const invitedUser = attendes?.map((item) => item?.attendeeUser?.id)
        return invitedUser?.includes(user?.id)
    }

    const handleFetchWorkshops = () => {
        setFetching(true)
        WorkShopService.getWorkshops(user?.id)
            .then((responses) => {
                const data = responses?.data?.data

                const optimizedData = Array.from(data ?? [], (item) => ({
                    sessionId: item?.id,
                    workshopId: item?.workshop?.id,
                    name: item?.summary,
                    description: item?.description,
                    type: item?.consultationType?.name,
                    isVisio: item?.consultationType?.id === 2,
                    alreadyMember: alreadyMember(item?.attendees),
                    startDate: UseParisDateTimeZone(item?.startDate, true).format(dateTimeFR).toString()
                }))

                setWorkshops(optimizedData.reverse())
                setFetching(false)
            })
            .catch((err) => {
                setFetching(false)
            })
    }

    useEffect(() => {
        handleFetchWorkshops()
    }, [isFocused])

    const renderItem = ({ item }) => <CustomWorkshopItem item={item} />

    return (
        <View style={styles.container}>
            {fetching ? (
                <ActivityIndicator color={baseColors.green.primary} size={"large"} style={{ padding: 30 }} />
            ) : (
                <FlatList
                    data={workshops}
                    contentContainerStyle={styles.contentContainer}
                    showsVerticalScrollIndicator={false}
                    ListEmptyComponent={<CustomEmptyData />}
                    renderItem={renderItem}
                    keyExtractor={(item) => item?.sessionId?.toString()}
                    refreshControl={<RefreshControl refreshing={fetching} onRefresh={handleFetchWorkshops} />}
                />
            )}
        </View>
    )
}

export default Ateliers
